<template>
  <div class="home">
    <section>
      <property-search
        :image="coverImage"
        title="Encuentra la propiedad adecuada para ti"
      />
    </section>
    <section>
      <section
        class="wrapper-featured-properties has-background-primary has-text-white"
      >
        <featured-properties />
      </section>
    </section>

    <section class="p-b-xl">
      <div class="container-help-messsage">
        <span class="help-message is-size-7-mobile">
          Desliza hacia los lados para navegar entre propiedades
        </span>
      </div>
      <property-list
        showMoreProperties
        ref="saleProperties"
        title="Propiedades en venta"
        :items="sales"
        @open-properties="openSales"
      >
      </property-list>
      <property-list
        showMoreProperties
        ref="rentProperties"
        title="Propiedades en renta"
        :items="rents"
        @open-properties="openRents"
      />
      <div class="has-text-centered m-t-lg">
        <b-button
          type="is-white"
          class="has-text-weight-bold has-text-link"
          @click="$router.push({ name: 'properties' })"
        >
          Ver más propiedades
        </b-button>
      </div>
    </section>

    <section class="has-background-light">
      <home-experience />
    </section>

    <section>
      <home-services />
    </section>

    <hr />

    <!-- <section>
      <home-zones @open-properties="openZone" />
    </section> -->

    <section>
      <main-contact />
    </section>
  </div>
</template>

<script>
import Properties from "@/services/properties";
import FeaturedProperties from "@/components/FeaturedProperties";
import MainContact from "@/components/MainContact";
import HomeExperience from "@/components/HomeExperience";
import HomeServices from "@/components/HomeServices";
// import HomeZones from "@/components/HomeZones";
import PropertyList from "@/components/PropertyList";
import PropertySearch from "@/components/PropertySearch";
import PropertyAdTypes from "@/constants/properties/ad-type";

import logoImg from "@/assets/images/logo.png";

export default {
  name: "home",

  components: {
    FeaturedProperties,
    MainContact,
    HomeExperience,
    HomeServices,
    // HomeZones,
    PropertyList,
    PropertySearch
  },

  metaInfo() {
    return {
      title: "Venta y renta de propiedades en Jalisco-CasaAdministraciones",
      titleTemplate: "%s",
      meta: [
        {
          name: "description",
          content:
            "Venta y renta de inmuebles, más de 50 años de servicio a nuestros propietarios e inquilinos nos colocan como líderes, tenemos propiedades en todo Jalisco"
        },
        {
          name: "og:title",
          content:
            "Venta y renta de propiedades en Jalisco-CasaAdministraciones"
        },
        {
          name: "og:description",
          content:
            "Venta y renta de inmuebles, más de 50 años de servicio a nuestros propietarios e inquilinos nos colocan como líderes, tenemos propiedades en todo Jalisco"
        },
        {
          name: "og:image",
          content: process.env.BASE_URL + logoImg
        },
        {
          name: "twitter:card",
          content: "summary_large_image"
        },
        {
          name: "twitter:title",
          content:
            "Venta y renta de propiedades en Jalisco-CasaAdministraciones"
        },
        {
          name: "twitter:description",
          content:
            "Venta y renta de inmuebles, más de 50 años de servicio a nuestros propietarios e inquilinos nos colocan como líderes, tenemos propiedades en todo Jalisco"
        },
        {
          name: "twitter:image",
          content: process.env.BASE_URL + logoImg
        }
      ],
      link: [
        {
          rel: "canonical",
          href: window.location.origin + this.$router.currentRoute.path
        }
      ]
    };
  },

  data() {
    return {
      sales: [],
      rents: []
    };
  },

  mounted() {
    this.$store.commit("filter/reset");
    this.getProperties();
  },

  computed: {
    coverImage() {
      const r = Math.floor(Math.random() * 4);
      const images = [
        "casas-administraciones-1.jpg",
        "casas-administraciones-2.jpg",
        "casas-administraciones-3.jpg",
        "casas-administraciones-4.jpg"
      ];
      return images[r];
    }
  },

  methods: {
    async getProperties() {
      const loadingComponentSale = this.$buefy.loading.open({
        container: this.$refs.saleProperties.$el
      });
      const loadingComponentRent = this.$buefy.loading.open({
        container: this.$refs.rentProperties.$el
      });
      const response = await Properties.getCatalog({ skip: 0, limit: 4 });
      this.sales = response.data.properties.sales;
      this.rents = response.data.properties.rents;
      loadingComponentSale.close();
      loadingComponentRent.close();
    },

    openSales() {
      this.$store.commit("filter/update_adtype", PropertyAdTypes.NUM_SALE);
      this.$router.push({ name: "properties" }).catch(err => {});
    },

    openRents() {
      this.$store.commit("filter/update_adtype", PropertyAdTypes.NUM_RENT);
      this.$router.push({ name: "properties" }).catch(err => {});
    },

    openAuctions() {
      this.$store.commit("filter/update_adtype", PropertyAdTypes.NUM_BOTH);
      this.$store.commit("filter/update_auction", "auction");
      this.$router.push({ name: "properties" }).catch(err => {});
    },

    openRentPlus() {
      this.$store.commit("filter/update_adtype", PropertyAdTypes.NUM_RENT_PLUS);
      this.$router.push({ name: "properties" }).catch(err => {});
    },

    openZone(zone) {
      this.$store.commit("filter/update_zones", zone);
      this.$router.push({ name: "properties" }).catch(err => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.ca-action {
  &:hover {
    cursor: pointer;
  }
}

.container-help-messsage {
  text-align: center;
  margin-top: -10px;

  .help-message {
    background-color: #1a4275 !important;
    color: white;
    padding: 5px 15px;
  }
}

@media only screen and (min-width: 769px) {
}
</style>
